export enum SubscriptionStatusType {
  None = 0,
  Active = 1,
  PastDue = 2,
  Cancelled = 3,
}
